import { render, staticRenderFns } from "./EditElektronik.vue?vue&type=template&id=2433a601&"
import script from "./EditElektronik.vue?vue&type=script&lang=js&"
export * from "./EditElektronik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports